import { useContext } from 'react';

import { XYChartScalesContext } from '../context/XYChartScales.context.js';

export const useXYChartScales = () => {
  const context = useContext(XYChartScalesContext);

  if (context === undefined) {
    throw new Error(
      'useXYChartScales must be used within a XYChartScalesContext',
    );
  }

  return context;
};
